<template>
  <div v-if="metas.total >= 1" class="pagination">
    <div class="pagination_limit">
      <ul>
        <li>Showing</li>
        <li>
          <select v-model="limit" class="custom-select custom-select-sm" :disabled="disabled">
            <option
              v-for="limitOption in limits"
              :key="limitOption"
              :value="limitOption"
            >
              {{ limitOption }}
            </option>
          </select>
        </li>
        <li>
          of
          <span class="pagination_total_row">
            {{ metas.total }} {{ metas.total > 1 ? 'rows' : 'row' }}
          </span>
        </li>
      </ul>
    </div>
    <div class="pagination_pages">
      <ul>
        <li>
          <a
            ref="firstPageButton"
            class="btn btn-icon"
            href="#"
            role="button"
            title="First"
            :disabled="disabled || metas.current_page === 1"
            @click="clickPage(1)"
          >
            <i class="ic ic-chevron-first"></i>
          </a>
        </li>
        <li>
          <a
            ref="previousPageButton"
            class="btn btn-icon"
            href="#"
            role="button"
            title="Prev"
            :disabled="disabled || metas.current_page <= 1"
            @click="metas.current_page >= 1 ? clickPage(metas.current_page - 1) : null"
          >
            <i class="ic ic-chevron-left"></i>
          </a>
        </li>
        <li>
          <input
            v-model="page"
            type="text"
            class="form-control"
            placeholder="Page"
            :disabled="disabled"
            @change="updatePage"
          />
        </li>
        <li>of <span class="pagination_total_pages"> {{ metas.last_page }} </span></li>
        <li>
          <a
            ref="nextPageButton"
            :class="[
              'btn',
              'btn-icon',
              {
                'disabled': disabled || metas.current_page >= metas.last_page
              }
            ]"
            href="#"
            role="button"
            title="Next"
            :disabled="disabled || metas.current_page >= metas.last_page"
            @click="metas.current_page <= metas.last_page ? clickPage(metas.current_page + 1) : null"
          >
            <i class="ic ic-chevron-right"></i>
          </a>
        </li>
        <li>
          <a
            ref="lastPageButton"
            class="btn btn-icon"
            href="#"
            role="button"
            title="Last"
            :disabled="disabled || metas.current_page == metas.last_page"
            @click="clickPage(metas.last_page)"
          >
            <i class="ic ic-chevron-last"></i>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MPagination',
  props: {
    metas: {
      type: Object,
      default: () => {
        return {
          current_page: 1,
          last_page: 1,
          per_page: 10,
          total: 1,
        };
      },
      validator(value) {
        return value.current_page && value.last_page && value.per_page && value.total;
      },
    },
    limits: {
      type: Array,
      default: () => {
        return [10, 20, 50, 100];
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      limit: 10,
      page: 1,
    };
  },
  watch: {
    'metas.per_page': function () {
      this.page = 1;
    },
    'metas.current_page': function () {
      this.page = this.metas.current_page;
    },
    limit(newValue) {
      this.$emit('update', { page: 1, limit: newValue });
    },
  },
  methods: {
    clickPage(number) {
      this.page = number;
      this.$emit('update', { page: number, limit: this.limit });
    },
    updatePage() {
      this.$emit('update', { page: this.page, limit: this.limit });
    },
  },
};
</script>

<style lang="scss" scoped>
.pagination {
  .btn:disabled,
  .btn.disabled {
    border: none;
    background-color: transparent;
  }
}
</style>
